import styled, { css } from 'styled-components';
import { Palette } from 'config';

const PADDING = '16px';

export const Container = styled.div`
  min-width: 768px;
  width: 65%;
`;

export const Form = styled.form`
  all: unset;
`;

export const Box = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 1px 3px rgba(30, 50, 70, 0.1), 0px 1px 2px rgba(30, 50, 70, 0.06);
  margin-bottom: 8px;
  .MuiDivider-root {
    border-bottom: 1px solid ${Palette.PrimaryGray._200};
  }
`;

export const Head = styled.h2`
  padding: 32px 40px 0;
  font-weight: 600;
  line-height: 32px;
`;
export const Field = styled.div`
  padding: 16px 40px 16px;
  display: flex;
  align-items: baseline;
  ${({ position }) =>
    position === 'top' &&
    css`
      align-items: flex-start;
    `}
  padding-bottom: ${({ middle }) => middle && 0}
`;

export const BtnGroup = styled.div`
  display: flex;
  margin: 24px 0 64px;
  gap: 16px;
`;

export const TextField = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.PrimaryGray._700};
`;

export const Title = styled.h2`
  font-weight: 500;
  font-size: 0.875em;
  line-height: 20px;
  color: ${Palette.PrimaryGray._700};
  width: 30%;
`;

export const FieldsWrap = styled.div`
  display: flex;
  width: 70%;
  gap: 48px;
`;

export const InputWrap = styled.div`
  position: relative;
`;

export const ActionField = styled.div`
  background: ${Palette.PrimaryGray._000};
  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  width: 100%;
  padding: ${PADDING};

  .MuiDivider-root {
    border-bottom: 1px solid ${Palette.PrimaryGray._200};
    margin: 16px -${PADDING} 12px;
  }
  #countries_clear_all {
    margin-left: -${PADDING};
  }
`;

export const ErrorWrap = styled.div`
  position: absolute;
  bottom: -4px;
  left: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  white-space: nowrap;
  color: ${Palette.Red._600};
`;
